var _excluded = ["value", "items", "separator", "onChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useCallback, useMemo } from 'react';
import { flattenItemsRecursive, setActiveRecursive } from './Select.utils';

/**
 * Выпадающий список с возможностью выбора нескольких значений.
 */
export var withMultiSelect = function withMultiSelect(View) {
  return /*#__PURE__*/forwardRef(function (_ref, ref) {
    var value = _ref.value,
        _ref$items = _ref.items,
        items = _ref$items === void 0 ? [] : _ref$items,
        _ref$separator = _ref.separator,
        separator = _ref$separator === void 0 ? ', ' : _ref$separator,
        onChange = _ref.onChange,
        rest = _objectWithoutProperties(_ref, _excluded);

    var isActive = useCallback(function (item) {
      return Boolean(value && value.includes(item.value));
    }, [value]);
    var viewValue = useMemo(function () {
      return flattenItemsRecursive(items).filter(isActive).map(function (item) {
        return item.label;
      }).join(separator);
    }, [value, items, isActive]);
    var viewItems = useMemo(function () {
      return setActiveRecursive(items, isActive);
    }, [value, items, isActive]);
    var onItemSelect = useCallback(function (item) {
      var set = new Set(value);

      if (set.has(item.value)) {
        set["delete"](item.value);
      } else {
        set.add(item.value);
      }

      onChange === null || onChange === void 0 ? void 0 : onChange(Array.from(set));
    }, [onChange]);
    return /*#__PURE__*/React.createElement(View, _extends({}, rest, {
      ref: ref,
      value: viewValue,
      items: viewItems,
      onItemSelect: onItemSelect
    }));
  });
};